import React from 'react';

export const PhoneBlueSM = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32}>
    <defs>
      <clipPath id="a">
        <path fill="#fff" stroke="#004f92" strokeWidth={1.8} d="M32 0v32H0V0z" />
      </clipPath>
    </defs>
    <g>
      <path
        fill="none"
        stroke="#004f92"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="m18.452 24.367.01.006a4.462 4.462 0 0 0 5.551-.609l.624-.624a1.488 1.488 0 0 0 0-2.1l-2.63-2.628a1.488 1.488 0 0 0-2.1 0h0a1.485 1.485 0 0 1-2.1 0l-4.208-4.208a1.488 1.488 0 0 1 0-2.1h0a1.487 1.487 0 0 0 0-2.1L10.97 7.372a1.488 1.488 0 0 0-2.1 0l-.624.624a4.463 4.463 0 0 0-.61 5.551l.007.01a40.263 40.263 0 0 0 10.809 10.81Z"
      />
    </g>
  </svg>
);
